import { render, staticRenderFns } from "./fatture.vue?vue&type=template&id=68d9b23f&"
import script from "./fatture.vue?vue&type=script&lang=js&"
export * from "./fatture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports